import Box from "@mui/material/Box";
import { styled } from "@mui/material";

export const NoMinHeightStyledBox = styled(Box)(() => ({
  minHeight: 0,
}));
